import { io } from 'socket.io-client'
import { SOCKET_IO_PATH, SOCKET_IO_PATH_V2 } from '@/constants'
import { getServiceURL } from './env.utils'

const socketClient = (v2 = false) => {
	return io(getServiceURL('socket-io'), {
		path: v2 ? SOCKET_IO_PATH_V2 : SOCKET_IO_PATH,
		transports: ['websocket'],
		autoConnect: false
	})
}

export default socketClient
